const unknownTab = 'unknown-tab';

export function getOrCreateTabId(win: Window | null): string {
    if (!win) return unknownTab;
    const key = 'auth-session-tab-id';

    try {
        const existing = win.sessionStorage?.getItem(key);
        if (existing) return existing;

        const uuid = win.crypto?.randomUUID?.();
        const generated = uuid ?? `tab-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
        win.sessionStorage?.setItem(key, generated);
        return generated;
    } catch {
        return unknownTab;
    }
}
